import React from 'react';
import { Heading } from '@vwfs-bronson/bronson-react';

export type PageHeaderProps = {
    title: string;
    testId?: string;
    /**
     * <h1> to <h6>
     */
    level?: 1 | 2 | 3 | 4 | 5 | 6;
};

export const PageHeader: React.FC<PageHeaderProps> = ({ title, testId, level = 1 as 3 | 1 | 2 | 6 | 4 | 5 }) => (
    <Heading level={level} testId={testId}>
        {title}
    </Heading>
);
